export default __webpack_public_path__ + "static/media/training-tour2.b78a58b4.svg";